module.exports = __webpack_public_path__ + "img/wifx-dark.3535cddf.svg";